import {
  EmailVerification,
  PromptLoadingSkeleton,
} from '@yuno/design-system-web'
import { User } from '@yuno/types'
import { useEmailVerification } from '@yuno/dashboard-api-mfe'
import { UseQueryResult } from 'react-query'
import { useEffect, useState } from 'react'
import { TEXTS } from '../../common/utils/constants'

export const EmailVerificationAuth = () => {
  const [stateResponse, setStateResponse] = useState()
  const urlParams = new URLSearchParams(window.location.search)
  let params = new Object()
  urlParams.forEach((value, key) => {
    params[key] = value
  })
  const { data }: UseQueryResult<User.UserResponseEmailVerification, any> =
    useEmailVerification(params['user'])

  const handleClick = () => {
    window.location.href = window.location.origin
  }

  useEffect(() => {
    data && setStateResponse(data)
  }, [data])

  if (!stateResponse) {
    return <PromptLoadingSkeleton />
  } else {
    return stateResponse === TEXTS.ALREADY_VERIFIED ? (
      <EmailVerification
        handleClick={handleClick}
        iconName={'X'}
        title={TEXTS.TITLE_ALREADY_VERIFY_EMAIL}
        subTitle={TEXTS.SUBTITLE_ALREADY_VERIFY_EMAIL}
        buttonText={TEXTS.BACK_TO_LOGIN}
        primary
      />
    ) : (
      <EmailVerification
        handleClick={handleClick}
        iconName={'Check'}
        title={TEXTS.TITLE_VERIFIED_EMAIL}
        subTitle={TEXTS.SUBTITLE_VERIFIED_EMAIL}
        buttonText={TEXTS.BACK_TO_LOGIN}
      />
    )
  }
}
